import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const getVendors = (filter, limit = 10, offset = 0) =>
  call(websocketFetch, 'get_vendors', { filter, limit, offset });
